import type { ParsedUrlQuery } from 'node:querystring';

import Router from 'next/router';

type RemoveParamOptions = {
  key: string;
  pathname: string;
  query: ParsedUrlQuery;
};

export const removeParamFromUrl = (options: RemoveParamOptions) => {
  const { key, pathname, query } = options;

  if (typeof window === 'undefined') {
    return;
  }

  if (query?.[key]) {
    const newQuery = { ...query };
    delete newQuery[key];

    Router.replace({ pathname, query: newQuery }, undefined, { shallow: true });
  }
};

export const addParamToQuery = (
  query: string,
  key: string,
  value: string | number | boolean
) => {
  const concatenator: string = query ? '&' : '?';

  return `${query}${concatenator}${key}=${value}`;
};
